// iter87.364 (user-provided, TruColor-verified) — NWSL club brand color
// pairs. Keyed by the name this app actually stores/displays — the
// stripped form (no trailing " W", see nwslplayoffs_engine.
// _clean_nwsl_team_name) — plus the common short/abbreviated aliases
// `api_football_highlightly._NWSL_ALIAS_TO_CANON` also recognizes, so
// this stays correct regardless of which form ends up on screen.
export const NWSL_TEAM_COLORS = {
    "Angel City": ["#212322", "#FFB3AB"],
    "Angel City FC": ["#212322", "#FFB3AB"],
    "ACFC": ["#212322", "#FFB3AB"],
    "Bay FC": ["#051C2C", "#F9423A"],
    "Bay": ["#051C2C", "#F9423A"],
    "Boston Legacy": ["#26D07C", "#D00070"],
    "Boston Legacy FC": ["#26D07C", "#D00070"],
    "Chicago Stars": ["#0C2340", "#DA291C"],
    "Chicago Stars FC": ["#0C2340", "#DA291C"],
    "Chicago Red Stars": ["#0C2340", "#DA291C"],
    "Denver Summit": ["#195F4C", "#6E85DC"],
    "Denver Summit FC": ["#195F4C", "#6E85DC"],
    "NJ/NY Gotham FC": ["#121212", "#A9F1F5"],
    "Gotham FC": ["#121212", "#A9F1F5"],
    "Gotham": ["#121212", "#A9F1F5"],
    "Houston Dash": ["#FF8100", "#215AA6"],
    "Dash": ["#FF8100", "#215AA6"],
    "Kansas City": ["#CF3339", "#6BD2F0"],
    "Kansas City Current": ["#CF3339", "#6BD2F0"],
    "KC Current": ["#CF3339", "#6BD2F0"],
    "Orlando Pride": ["#5E289A", "#FCF8E7"],
    "Pride": ["#5E289A", "#FCF8E7"],
    "Racing Louisville": ["#C3A6E4", "#170031"],
    "Racing Louisville FC": ["#C3A6E4", "#170031"],
    "San Diego Wave": ["#152241", "#FC1097"],
    "San Diego Wave FC": ["#152241", "#FC1097"],
    "Washington Spirit": ["#D21E25", "#1D2D53"],
    "Spirit": ["#D21E25", "#1D2D53"],
    "Portland Thorns": ["#D21E25", "#000000"],
    "Portland Thorns FC": ["#D21E25", "#000000"],
    "Thorns": ["#D21E25", "#000000"],
    "Utah Royals": ["#13294B", "#A6192E"],
    "Utah Royals FC": ["#13294B", "#A6192E"],
    "North Carolina Courage": ["#104275", "#AB1D37"],
    "NC Courage": ["#104275", "#AB1D37"],
    "Courage": ["#104275", "#AB1D37"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback so an unmapped name still renders.
export function nwslTeamColorPair(name) {
    return NWSL_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
